export default __webpack_public_path__ + "static/media/vulf-mono.9ba7e375.ttf";